module.exports = __webpack_public_path__ + "img/login_logo_comscore.6ff885ea.png";